import { makeAutoObservable, runInAction } from 'mobx'
import { logger } from 'shared/lib'
import { paginationCountList } from 'shared/ui/Table/constants/constants'
import { UsersApi } from 'entities/Users'
import type { IPaginationSourceType } from 'entities/Users/api/types'

export class TableLimitStore {
  private _limitsMap = new Map<IPaginationSourceType, number>()
  private _initialized = false

  constructor() {
    makeAutoObservable(this)
  }

  get initialized() {
    return this._initialized
  }

  init = async () => {
    try {
      const { data } = await UsersApi.getUsersUiSettings('pagination')
      runInAction(() => {
        data.data?.items.forEach((item) => {
          const colonIndex = item.lastIndexOf(':')
          if (colonIndex === -1) return
          const key = item.slice(0, colonIndex) as IPaginationSourceType
          const limit = parseInt(item.slice(colonIndex + 1), 10)
          if (!isNaN(limit)) this._limitsMap.set(key, limit)
        })
        this._initialized = true
      })
    } catch (e) {
      logger.error(e)
      runInAction(() => {
        this._initialized = true
      })
    }
  }

  getLimit = (key?: IPaginationSourceType): number | undefined => {
    if (!key) return undefined
    return this._limitsMap.get(key)
  }

  setLimit = (key: IPaginationSourceType, limit: number) => {
    if (this._limitsMap.get(key) === limit) return
    this._limitsMap.set(key, limit)
    const items = Array.from(this._limitsMap.entries()).map(([k, v]) => `${k}:${v}`)
    UsersApi.updateUsersUiSettings({ source_type: 'pagination', items }).catch(logger.error)
  }

  reduceLimit = (key: IPaginationSourceType, limit: number) => {
    const lowestLimit = paginationCountList[0]
    if (limit === lowestLimit) return limit
    this.setLimit(key, lowestLimit)
    return lowestLimit
  }
}

export const tableLimitStore = new TableLimitStore()
